<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    scrollTop: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    loaded: false,
    resources: [
      {
        waiting: false,
        width: 1000 * 0.74,
        height: 1941 * 0.74,
        view: {
          pc: [753, 902]
        },
        backgroundColor: '#FFF',
        shift: 0.06,
        images: [
          {
            name: 'back-angry',
            url: '/assets/images/top-visual-1-1a.png',
            style: {
              zIndex: 1
            },
            size: [486, 445],
            position: [38.4, 14.8]
          },
          {
            name: 'back-girl',
            url: '/assets/images/top-visual-1-1b.png',
            style: {
              zIndex: 1
            },
            size: [350, 576],
            position: [75.9, 42.8]
          },
          {
            name: 'bill',
            url: '/assets/images/top-visual-1-1c.png',
            style: {
              zIndex: 2
            },
            size: [151, 399],
            position: [54, 75]
          },
          {
            name: 'laurent',
            url: '/assets/images/top-visual-1-2.png',
            style: {
              zIndex: 2
            },
            size: [556, 629],
            position: [62.7, 26.7]
          },
          {
            name: 'back-shooter',
            url: '/assets/images/top-visual-1-3.png',
            style: {
              zIndex: 2
            },
            size: [329, 450],
            position: [21, 47.25]
          },
          {
            name: 'pola',
            url: '/assets/images/top-visual-1-4.png',
            style: {
              zIndex: 3
            },
            size: [409, 482],
            position: [43, 47.5]
          },
          {
            name: 'abbie',
            url: '/assets/images/top-visual-1-5.png',
            style: {
              zIndex: 4
            },
            size: [317, 561],
            position: [63.7, 45]
          },
          {
            name: 'edamame',
            url: '/assets/images/top-visual-1-6.png',
            style: {
              zIndex: 5
            },
            size: [493, 506],
            position: [31.5, 20.5]
          }
        ]
      },
      {
        waiting: true,
        width: 800,
        height: 1131,
        backgroundColor: '#FFF',
        shift: 0,
        images: [
          /* {
            url: '/assets/images/top-visual-2-wall.jpg',
            style: {
              zIndex: 1
            },
            size: [1912, 1436],
            position: [50, 50]
          }, */
          {
            url: '/assets/images/top-visual-2-poster-back.jpg',
            style: {
              zIndex: 2,
              transform: 'rotate(-3deg)'
            },
            size: [712, 1008],
            position: [50, 50]
          },
          {
            url: '/assets/images/top-visual-2-poster-top.png',
            style: {
              zIndex: 4,
              transform: 'rotate(-3deg)'
            },
            size: [712, 1008],
            position: [50, 50]
          },
          {
            url: '/assets/images/top-visual-2-poster-bottom.png',
            style: {
              zIndex: 4,
              transform: 'rotate(-3deg)'
            },
            size: [712, 1008],
            position: [50, 50]
          },
          {
            name: 'hung-edamame',
            url: '/assets/images/top-visual-2-edamame2.png',
            style: {
              zIndex: 3,
              transform: 'rotate(-3deg)'
            },
            size: [658, 1100], // 1.6714 983 1643
            position: [70.97, 18]
          }
        ]
      },
      {
        name: 'kv3',
        waiting: false,
        width: 375 * 3.105,
        height: 728 * 3.105,
        backgroundColor: '#FFF',
        shift: 0.06,
        images: [
          {
            name: 'kv3-dorothy',
            url: '/assets/images/top-visual-3-1-dorothy.png',
            style: {
              zIndex: 6
            },
            // size: [1057, 1773],
            // size: [1220 * 0.87, 2265 * 0.87],
            // size: [464 * 2.27, 768 * 2.27],
            size: [1220 * 0.87, 2010 * 0.87],
            position: [54.2, 36.25]
          },
          {
            name: 'kv3-oz',
            url: '/assets/images/top-visual-3-2-oz.png',
            style: {
              zIndex: 5
            },
            size: [739 * 0.87, 1618 * 0.87],
            // size: [739, 1618],
            // size: [351 * 1.85, 768 * 1.85],
            position: [57.25, 27.75]
          },
          {
            name: 'kv3-cynthia',
            url: '/assets/images/top-visual-3-3-cynthia.png',
            style: {
              zIndex: 4
            },
            size: [559, 784],
            position: [24, 26]
          },
          {
            name: 'kv3-abbie',
            url: '/assets/images/top-visual-3-4-abbie.png',
            style: {
              zIndex: 4
            },
            size: [555, 593],
            position: [67, 26.6]
          },
          {
            name: 'kv3-shanghi',
            url: '/assets/images/top-visual-3-5-shanghi.jpg',
            style: {
              zIndex: 2
            },
            // size: [825 * 0.87, 952 * 0.87],
            size: [666 * 1.07, 768 * 1.07],
            position: [24, 9.9]
          },
          {
            name: 'kv3-suzaku',
            url: '/assets/images/top-visual-3-6-suzaku.jpg',
            style: {
              zIndex: 2
            },
            size: [907 * 0.87, 993 * 0.87],
            position: [83.18, 10.7]
          },
          {
            name: 'kv3-edamame',
            url: '/assets/images/top-visual-3-7-edamame.png',
            style: {
              zIndex: 10
            },
            size: [215, 746],
            position: [63.25, 33]
          },
          {
            name: 'kv3-laurent',
            url: '/assets/images/top-visual-3-7-laurent.png',
            style: {
              zIndex: 10
            },
            size: [235, 822],
            position: [35, 33.25]
          },
          /* {
            name: 'kv3-copy-pc',
            url: '/assets/images/top-visual-3-copy.png',
            style: {
              zIndex: 6
            },
            size: [60 * 1.6, 754 * 1.6],
            position: [7, 39],
            xfixed: true
          },
          {
            name: 'kv3-copy-sp',
            url: '/assets/images/top-visual-3-copy.png',
            style: {
              zIndex: 6
            },
            size: [60 * 1.6, 754 * 1.6],
            position: [7, 45]
          }, */
          {
            name: 'kv3-kim',
            url: '/assets/images/top-visual-3-8-kim.png',
            style: {
              zIndex: 3
            },
            size: [203, 208],
            position: [20.2, 36.6]
          },
          {
            name: 'kv3-kudo',
            url: '/assets/images/top-visual-3-8-kudo.png',
            style: {
              zIndex: 3
            },
            size: [123, 93],
            position: [79.2, 31.1]
          }/* ,
          {
            name: 'kv3-hashtag',
            url: '/assets/images/top-visual-3-9.png',
            style: {
              zIndex: 11
            },
            size: [848, 174],
            position: [50, 33]
          },
          {
            name: 'kv3-copy',
            url: '/assets/images/top-visual-3-10.png',
            style: {
              zIndex: 12
            },
            size: [568, 169],
            position: [61.5, 37.2]
          } */
        ]
      },
      {
        name: 'kv4',
        waiting: false,
        width: 375 * 3.105,
        height: 728 * 3.105,
        backgroundColor: '#FFF',
        shift: 0,
        images: [
          {
            name: 'kv4',
            url: '/assets/images/top-visual-4.jpg',
            style: {
              zIndex: 1
            },
            size: [1250 * 0.83, 1768 * 0.83],
            position: [50, 32.4]
          },
          {
            name: 'kv4-logo-mobile',
            url: '/assets/images/top-visual-4-logo.png',
            style: {
              zIndex: 2
            },
            size: [975 * 0.83, 720 * 0.83],
            position: [50, 63]
          },
          {
            name: 'kv4-logo',
            url: '/assets/images/top-visual-4-logo.png',
            style: {
              zIndex: 2
            },
            size: [975 * 0.48, 720 * 0.48],
            position: [50, 42]
          }
        ]
      }
    ]
  }),
  computed: {
    source () {
      return this.resources[this.index - 1]
    }
  },
  watch: {
    scrollTop: {
      immediate: true,
      handler (value) {
        this.source.images.forEach(image => {
          if (image.el && image.style.zIndex) {
            const shift = -value * image.style.zIndex * this.source.shift
            image.el.style.top = this.getPositionTop(image, shift)
          }
        })
      }
    }
  },
  methods: {
    getBackground (image) {
      return `url(${image.url})`
    },
    getPositionLeft (image) {
      const width = (image.size[0] / this.source.width) / 2 * 100
      return `calc(${image.position[0]}% - ${width}%)`
    },
    getPositionTop (image, shift = 0) {
      const height = ((image.size[1] + shift) / this.source.height) / 2 * 100
      return `calc(${image.position[1]}% - ${height}%)`
    },
    getSizeWidth (image) {
      return (image.size[0] / this.source.width) * 100 + '%'
    },
    getSizeHeight (image) {
      return (image.size[1] / this.source.height) * 100 + '%'
    },
    setCanvasSize () {
      this.$refs.canvas.style.paddingTop = this.source.height / this.source.width * 100 + '%'
    },
    loading () {
      let count = 0
      this.source.images.forEach((image) => {
        const img = document.createElement('img')
        img.src = image.url
        img.addEventListener('load', () => {
          count++
          if (count === this.source.images.length) {
            this.loaded = true
          }
        })
      })
    }
  },
  mounted () {
    this.setCanvasSize()
    const def = {width: 'px', height: 'px', left: '%', top: '%'}
    this.source.images.forEach(image => {
      const div = document.createElement('div')
      for (var key in image.style) {
        div.style[key] = image.style[key] + (def[key] || '')
      }
      div.style.width = this.getSizeWidth(image)
      div.style.height = this.getSizeHeight(image)
      div.style.top = this.getPositionTop(image)
      div.style.left = this.getPositionLeft(image)
      div.style.backgroundImage = this.getBackground(image)
      div.classList.add('image')
      if (image.name) {
        div.classList.add(image.name)
      }
      this.$refs.canvas.appendChild(div)
      image.el = div
    })
    this.$refs.background.style.backgroundColor = this.source.backgroundColor
    if (this.source.waiting) {
      this.loading()
    } else {
      this.loaded = true
    }
  }
}
</script>

<template>
  <div class="top-visual" ref="background" :class="{hung: index === 2, kv3: index === 3, kv4: index === 4}">
    <div class="canvas-wrapper">
      <div
        class="canvas"
        ref="canvas"
        v-show="loaded"
      >
      </div>
      <div class="is-hidden-not-mobile">
        <div class="top-visual-logo image" v-if="index === 1 || index === 3"></div>
        <div class="top-visual-logo-v4-pre image" v-if="index === 5"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.top-visual {
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  z-index: -1;
  @include is-mobile {
    height: calc(100vw * 75 / 43);
    //max-height: 728px;
  }
  @include is-not-mobile {
    padding-left: 10rem;
    min-width: 65rem;
    min-height: 48rem;
  }
  .canvas-wrapper {
    position: relative;
    width: 100%;
    @include is-mobile {
      height: calc(100vw * 75 / 43);
      //max-height: 728px;
    }
    @include is-not-mobile {
      height: 100vh;
      max-height: 80rem;
      width: calc(100vh * 0.833);
      max-width: 75rem;
      min-width: 40rem;
      margin: auto;
    }
    @include is-mobile {
      .top-visual-logo {
        background-image: url(/assets/images/top-visual-logo_2x.png);
        width: 100%;
        height: 13.5rem;
        bottom: 7.5rem;
        z-index: 11;
      }
    }
  }
  .canvas {
    position: absolute;
    top: 0;
    @include is-mobile {
      width: 100%;
      right: 0;
    }
    @include is-not-mobile {
      width: calc(100%);
      right: 4%;
    }
  }
  .image {
    position: absolute;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  &.hung {
    background-image: url(/assets/images/top-visual-2-wall.jpg);
    .canvas-wrapper {
      @include is-mobile {
        max-width: calc(728px * 0.707);
        width: 112%;
        left: -6%;
        TOP: 4%;
        margin: auto;
      }
      @include is-not-mobile {
        width: calc(100vh * 0.707);
        min-width: 35rem;
      }
    }
  }
  .hung-edamame {
    transform-origin: center -200px;
    animation: hung 3s ease-in-out 0s infinite alternate;
  }
  @keyframes hung {
    0% {transform: rotateZ(3deg)}
    100% {transform: rotateZ(-3deg)}
  }

  &.kv3 {
    .canvas-wrapper {
      @include is-not-mobile {
        width: calc(100vh * 0.895);
        left: calc(100vh * 0.03);
      }
    }
  }

  &.kv4 {
    .canvas-wrapper {
      @include is-not-mobile {
        width: calc(100vh * 0.985);
        min-width: 30rem;
        left: calc(100vh * 0.01);
      }
    }
  }

/**
 * visual 1
 */
  @keyframes top-visual-1-laurent {
    0% {transform: translate(-200px, 50px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-1-pola {
    0% {transform: translate(200px, 0); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-1-abbie {
    0% {transform: translate(-200px, -50px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-1-edamame {
    0% {transform: translate(600px, 0px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-1-angry {
    0% {transform: translate(150px, 50px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-1-shooter {
    0% {transform: translate(150px, -50px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-1-girl {
    0% {transform: translate(-150px, -50px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-1-bill {
    0% {transform: translate(0, -50px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  .back-angry {
    animation: top-visual-1-angry .3s .875s ease-out forwards;
    transform: translate(150px, 50px);
    opacity: 0;
  }
  .back-girl {
    animation: top-visual-1-girl .3s .625s ease-out forwards;
    transform: translate(-150px, -50px);
    opacity: 0;
  }
  .back-shooter {
    animation: top-visual-1-shooter .3s .75s ease-out forwards;
    transform: translate(150px, -50px);
    opacity: 0;
  }
  .bill {
    animation: top-visual-1-bill 1s .75s ease-out forwards;
    transform: translate(0, -50px);
    opacity: 0;
  }
  .laurent {
    animation: top-visual-1-laurent .3s .25s ease-out forwards;
    transform: translate(-200px, 50px);
    opacity: 0;
  }
  .pola {
    animation: top-visual-1-pola .3s .5s ease-out forwards;
    transform: translate(200px, 0);
    opacity: 0;
  }
  .abbie {
    animation: top-visual-1-abbie .3s .75s ease-out forwards;
    transform: translate(-200px, -50px);
    opacity: 0;
  }
  .edamame {
    animation: top-visual-1-edamame .3s 1s ease-out forwards;
    transform: translate(600px, 0px);
    opacity: 0;
  }

/**
 * visual 3
 */
  @keyframes top-visual-3-dorothy {
    0% {transform: translate(0px, 400px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-oz {
    0% {transform: translate(-100px, 100px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-cynthia {
    0% {transform: translate(150px, 0); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-abbie {
    0% {transform: translate(-150px, -50px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-shanghi {
    0% {transform: translate(150px, 50px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-suzaku {
    0% {transform: translate(-150px, 50px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-laurent {
    0% {transform: translate(300px, -200px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-edamame {
    0% {transform: translate(-300px, -200px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-kudo {
    0% {transform: translate(-100px, 0px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-kim {
    0% {transform: translate(100px, 0px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-hashtag {
    0% {transform: translate(-500px, 75px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  @keyframes top-visual-3-copy {
    0% {transform: translate(-500px, 125px); opacity: 0;}
    100% {transform: translate(0, 0); opacity: 1;}
  }
  .kv3-dorothy {
    animation: top-visual-3-dorothy .6s .4s ease-out forwards;
    transform: translate(0px, 400px);
    opacity: 0;
  }
  .kv3-oz {
    animation: top-visual-3-oz .3s .6s ease-out forwards;
    transform: translate(-100px, 100px);
    opacity: 0;
  }
  .kv3-cynthia {
    animation: top-visual-3-cynthia .3s .7s ease-out forwards;
    transform: translate(150px, 0);
    opacity: 0;
  }
  .kv3-abbie {
    animation: top-visual-3-abbie .3s .75s ease-out forwards;
    transform: translate(-150px, -50px);
    opacity: 0;
  }
  .kv3-shanghi {
    animation: top-visual-3-shanghi .3s .875s ease-out forwards;
    transform: translate(150px, 50px);
    opacity: 0;
  }
  .kv3-suzaku {
    animation: top-visual-3-suzaku .3s 1s ease-out forwards;
    transform: translate(-150px, 50px);
    opacity: 0;
  }
  .kv3-laurent {
    animation: top-visual-3-laurent .25s 1.4s linear forwards;
    transform: translate(300px, -200px);
    opacity: 0;
  }
  .kv3-edamame {
    animation: top-visual-3-edamame .25s 1.4s linear forwards;
    transform: translate(-300px, -200px);
    opacity: 0;
  }
  .kv3-kudo {
    animation: top-visual-3-kudo .2s 2.75s linear forwards;
    transform: translate(-100px, 0px);
    opacity: 0;
  }
  .kv3-kim {
    animation: top-visual-3-kim .2s 2.5s linear forwards;
    transform: translate(100px, 0px);
    opacity: 0;
  }
  .kv3-hashtag {
    animation: top-visual-3-hashtag .15s 1.7s linear forwards;
    transform: translate(-500px, 75px);
    opacity: 0;
  }
  .kv3-copy {
    animation: top-visual-3-copy .15s 1.8s linear forwards;
    transform: translate(-500px, 125px);
    opacity: 0;
  }

/**
 * visual 4
 */
  .kv4-logo {
    @include is-mobile {
      display: none;
    }
  }
  .kv4-logo-mobile {
    @include is-not-mobile {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/top-visual.vue